import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Roles from "@/components/landing/Roles";
import Docs from "@/components/landing/Docs";
import Footer from "@/components/landing/Footer";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { PageSeo } from "@/components/seo/PageSeo";
import { JsonLd } from "@/components/seo/JsonLd";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";

const Index = () => {
  const { pricingEnabled } = usePlatformSettings();
  return (
    <div className="min-h-screen bg-background">
      <PageSeo
        title="Upbrief — Collect Team Updates, Generate Executive Summaries"
        description="Stop chasing updates. Upbrief sends personalized collection links, gathers responses, and uses AI to create polished executive reports ready to share."
        path="/"
      />
      <JsonLd
        data={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Upbrief",
            url: "https://upbrief.app",
            logo: "https://upbrief.app/upbrief-icon.png",
            sameAs: ["https://upbrief.app"],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Upbrief",
            url: "https://upbrief.app",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://upbrief.app/?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <Navbar />
      <main>
        <Hero />
        <Roles />
        <Features />

        {/* CTA — Pricing button only when pricing is live */}
        <section className="py-16 bg-muted/30">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-3">
            Stop asking twice.
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-6">
            {pricingEnabled ? "Free to start." : "Free while in early access."} Takes five minutes to set up your first report.
          </p>
          <Link to={pricingEnabled ? "/pricing" : "/signup"}>
            <Button size="lg" className="gap-2">
              {pricingEnabled ? "View Pricing" : "Get Started Free"} <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
        </section>

        <Docs />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
